/* unplugin-vue-components disabled */import { render } from "./autosave.vue?vue&type=template&id=6927a1dc&scoped=true"
import script from "./autosave.vue?vue&type=script&lang=js"
export * from "./autosave.vue?vue&type=script&lang=js"

import "./autosave.vue?vue&type=style&index=0&id=6927a1dc&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6927a1dc"],['__file',"src/controls/autosave.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6927a1dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6927a1dc', __exports__)) {
    api.reload('6927a1dc', __exports__)
  }
  
  module.hot.accept("./autosave.vue?vue&type=template&id=6927a1dc&scoped=true", () => {
    api.rerender('6927a1dc', render)
  })

}


export default __exports__